import axios from './axios';

// ----------------------------------------------------------------------

/**
 * Tokens are plain hex strings (not JWTs), so we just check they exist and are non-empty.
 */
const isValidToken = (accessToken) => {
  if (!accessToken || accessToken === 'undefined' || accessToken === 'null') {
    return false;
  }
  return accessToken.length > 10;
};

// ----------------------------------------------------------------------

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
